import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.NODE_ENV === 'development'
        ? 'http://192.168.1.5:8088/wechat':'/wechat',
    timeout: 10000000000000, //响应时长10s
    headers: {
        'X-TEST-HEADER': 'WEBSITE BLOG APPLICATION',
    }, //自定义请求头
})

// 请求拦截器
axiosInstance.interceptors.request.use(
    config => {
        // 可以在这里添加认证token等
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
axiosInstance.interceptors.response.use(
    response => {
        console.log('response',response);
        return response.data
    },
    error => {

        console.error('API请求错误:', error)
        return Promise.reject(error)
    }
)
export default axiosInstance;
